import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const comment = {
  fetchComments: lazyModuleMethod(() => import('./fetchComments'), 'default'),
  deleteComment: lazyModuleMethod(() => import('./deleteComment'), 'default'),
  postComment: lazyModuleMethod(() => import('./postComment'), 'default'),
  updateComment: lazyModuleMethod(() => import('./updateComment'), 'default'),
  banUser: lazyModuleMethod(() => import('./banUser'), 'default'),
}
